const rootPath = "https://demo.chinookdt.com/videos/software/Structural/";

export const tabsVideos = {
  spec: rootPath + "spec/SPEC.mp4",
  partsLibrary: rootPath + "Parts%20library/PARTS_LIBRARY.mp4",
  //   estimation: rootPath + "Estimation/",
  //   modeling: rootPath + "Modeling/",
};
